import React from 'react';
import styled, { keyframes } from 'styled-components';

const loading = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
`;

const CardContainer = styled.div`
  flex: 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

const ImageSection = styled.div`
  background: #f5f5f5;
  padding: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 280px;
`;

const ContentSection = styled.div`
  padding: 20px;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
`;

const Skeleton = styled.div`
  background: linear-gradient(
    90deg,
    #e0e0e0 0%,
    #f0f0f0 50%,
    #e0e0e0 100%
  );
  background-size: 200% 100%;
  animation: ${loading} 1.5s ease-in-out infinite;
  border-radius: 8px;
`;

const SkeletonImage = styled(Skeleton)`
  width: 200px;
  height: 200px;
  border-radius: 12px;
`;

const SkeletonTitle = styled(Skeleton)`
  height: 20px;
  width: 70%;
  margin-bottom: 16px;
`;

const SkeletonButton = styled(Skeleton)`
  flex: 1;
  height: 44px;
`;

const ProductCardSkeleton = () => {
  return (
    <CardContainer>
      <ImageSection>
        <SkeletonImage />
      </ImageSection>
      
      <ContentSection>
        <SkeletonTitle />
        
        <ButtonGroup>
          <SkeletonButton />
          <SkeletonButton />
        </ButtonGroup>
      </ContentSection>
    </CardContainer>
  );
};

export default ProductCardSkeleton;